import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    size: {
      type: String as PropType<'large' | 'medium'>,
      default: 'large',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["b-icon-button", `b-icon-button--${__props.size}`]),
    type: "button"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})